import * as React from 'react';
import * as ReactToPrint from 'react-to-print';
import {
  AttendantSheetCard,
  CardActions,
  CardText,
  ClassName,
  CourseCode,
  CourseName,
  Image,
  PageWrapper,
  SheetsWrap,
  ViewButton,
  SortIcon,
  SortSpan,
  Pagination,
  PaginationIcon,
} from './styles';
import {
  UpperPartWrap,
  UpperTittleWrap,
  H2,
  H6,
  SearchBar,
  SearchBarWrap,
  SearchIcon,
} from '../signInvigilatorRecords/styles';
import { Modal, UnderDevelopment } from '../../../../../components';
import { mockdata } from './mockdata';

export const AttendanceSheets = (): JSX.Element => {
  const [sortOption, setSortOption] = React.useState<string>('');
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [isShowSortDropDown, setIsShowSortDropDown] = React.useState<boolean>(false);
  const [imgUrl, setImgUrl] = React.useState<string>('');
  const attendantSheetRef = React.useRef(null);

  const handlePrint = ReactToPrint.useReactToPrint({
    content: () => attendantSheetRef.current,
    documentTitle: `attendance-sheet`,
  });

  const toggleModal = (): void => {
    setIsModalOpen(!isModalOpen);
  };

  // sort data.
  React.useEffect(() => {
    // make a query to get sorted attendant sheet base on sort option
    console.log({ sortOption });
  }, [sortOption]);

  return (
    <>
      {true ? (
        <div className="h-screen flex flex-col items-center justify-center">
          <UnderDevelopment />
        </div>
      ) : (
        <PageWrapper>
          <UpperPartWrap style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
            <UpperTittleWrap>
              <H6>Students</H6>
              <H2>Attendant Sheets</H2>
            </UpperTittleWrap>
            <div style={{ display: 'flex', justifyItems: 'center', justifyContent: 'center' }}>
              <SearchBarWrap>
                <SearchBar placeholder="Search records by class, course name, course-code" />
                <SearchIcon className="fas fa-search" />
              </SearchBarWrap>
              <div>
                <SortSpan onClick={() => setIsShowSortDropDown(!isShowSortDropDown)}>
                  <SortIcon className="fas fa-sort-amount-down" />
                </SortSpan>
                {isShowSortDropDown && (
                  <div
                    className="bg-slate-100 shadow-sm z-10 -ml-10
                  p-4 border border-gray-100 select-none slide-bottom rounded-lg"
                  >
                    <h2 className="font-thin">Sort by :</h2>
                    <div className="flex flex-col divide-gray-300 divide-y">
                      <div
                        onClick={() => setSortOption('room')}
                        className="py-2 text-center font-medium cursor-pointer"
                      >
                        Room
                      </div>
                      <div
                        onClick={() => setSortOption('session')}
                        className="py-2 text-center  font-medium cursor-pointer"
                      >
                        Session
                      </div>
                      <div
                        onClick={() => setSortOption('date')}
                        className="py-2 text-center  font-medium cursor-pointer"
                      >
                        Date
                      </div>
                      <div
                        onClick={() => setSortOption('course-name')}
                        className="py-2 text-center  font-medium cursor-pointer"
                      >
                        Course Name
                      </div>
                      <div
                        onClick={() => setSortOption('course-code')}
                        className="py-2 text-center  font-medium cursor-pointer"
                      >
                        Course Code
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </UpperPartWrap>
          <SheetsWrap>
            {mockdata.map((data, index) => (
              <AttendantSheetCard key={index}>
                <Image src={data.imgSrc} />
                <CardText>
                  <CourseCode>{data.courseCode}</CourseCode>
                  <CourseName>{data.courseName}</CourseName>
                  <ClassName>{data.cls}</ClassName>
                </CardText>
                <CardActions>
                  <ViewButton
                    onClick={() => {
                      setImgUrl(data.imgSrc);
                      toggleModal();
                    }}
                  >
                    View
                  </ViewButton>
                </CardActions>
              </AttendantSheetCard>
            ))}
          </SheetsWrap>
          <Pagination>
            <PaginationIcon className="fas fa-caret-left" /> 2 of 5{' '}
            <PaginationIcon className="fas fa-caret-right" />
          </Pagination>
          <Modal modalIsOpen={isModalOpen} toggleModal={toggleModal}>
            <div className="flex justify-center flex-col pb-10">
              <img
                className="w-10/12 h-[42rem] object-center 2xl:h-[48rem] mx-auto"
                ref={attendantSheetRef}
                src={imgUrl}
                alt="attendant sheet"
              />
              <button
                onClick={handlePrint}
                className="py-2.5 px-5 rounded-md text-white font-bold bg-blue-700 mx-auto mt-3"
              >
                Print Attendant Sheet
              </button>
            </div>
          </Modal>
        </PageWrapper>
      )}
    </>
  );
};
